import promis from './promis'
import API from '@/api/index'
import tool from '@/utils/tool'

export default {
	// 数据更新时间获取
	getNewDate: function (parame) {
		return promis.get(API.Homeapi + '/topHome/protected/queryLastUpdateDate?' + parame)
	},
	// 首页数据获取
	getHomeData: function (parame) {
		return promis.get(API.Homeapi + '/topHome/protected/queryData?' + parame)
	},
	// 个股榜单列表数据获取
	getStockList: function (parame) {
		return promis.get(API.Homeapi + '/stock/protected/stockList?' + parame)
	},
	// 成交明细数据获取
	getDealDetails: function (parame) {
		return promis.get(API.Homeapi + '/stock/protected/stockDetail?' + parame)
	},
	// 成交明细上榜日期查询
	getStockTopDate: function (parame) {
		return promis.get(API.Homeapi + '/stock/protected/queryStockTopDate?' + parame)
	},
	// 成交明细上榜理由查询
	getStockTopType: function (parame) {
		return promis.get(API.Homeapi + '/stock/protected/queryStockTopType?' + parame)
	},
	// 成交统计数据获取
	getDealStatistics: function (parame) {
		return promis.get(API.Homeapi + '/stock/protected/stockStatistics?' + parame)
	},
	// 活跃榜数据获取
	getActivePage: function (parame) {
		return promis.get(API.Homeapi + '/businessHall/protected/activeList?' + parame)
	},
	// 实力榜数据获取
	getStrengthPage: function (parame) {
		return promis.get(API.Homeapi + '/businessHall/protected/powerList?' + parame)
	},
	// 做T榜数据获取
	getTPage: function (parame) {
		return promis.get(API.Homeapi + '/businessHall/protected/tradeList?' + parame)
	},
	// 营业部详情数据获取
	getBusinessDetails: function (parame) {
		return promis.get(API.Homeapi + '/businessHall/protected/hallDetail?' + parame)
	},
	// 协同营业部数据获取
	getTeamPage: function (parame) {
		return promis.get(API.Homeapi + '/businessHall/protected/synergyHall?' + parame)
	},
	postReqXml: function (action, url, params, jsCallback, fun) {
		tool.getZfthq(action, params, jsCallback, (res) => {
			fun && fun(res)
		}, () => {
			promis.posthq(API.reqxml + url, params).then(res => {
				fun && fun(res)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/servers/postageMgr.js